import { Component, inject } from '@angular/core';
import { LoaderService } from '../../services/loader.service';
import { CommonModule } from '@angular/common';

@Component({
	standalone: true,
	selector: 'app-loader',
	imports: [CommonModule],
	templateUrl: './loader.component.html',
	styleUrls: ['./loader.component.css']
})
export class LoaderComponent {
	private loaderService = inject(LoaderService);
	// isLoading$ = this.loaderService.isLoading$;

	constructor() {}
}
